import { createReducer } from '@reduxjs/toolkit';
import {
  fetchFerryServicesFailure,
  fetchFerryServicesStarted,
  fetchFerryServicesSucceeded,
  setFerryServices,
} from 'redux/actions/service';

const serviceFerryGrouping =
  ecom.redux_initial_state.sealink?.ferryGrouping?.serviceFerryGrouping;

export const initialState = {
  ferryGrouping: serviceFerryGrouping || [{}],
  accommodationGrouping: [],
  experienceGrouping: [],
  fetchingStatus: [{}],
};

export default createReducer(initialState, {
  [fetchFerryServicesStarted]: (state, action) => {
    // TODO: move this value to redux store later
    const currentFerryGroupingIndex = 0;
    state.fetchingStatus[currentFerryGroupingIndex][
      action.payload.segmentId
    ] = true;
  },
  [fetchFerryServicesSucceeded]: (state, action) => {
    // TODO: move this value to redux store later
    const currentFerryGroupingIndex = 0;
    state.fetchingStatus[currentFerryGroupingIndex][
      action.payload.segmentId
    ] = false;
  },
  [fetchFerryServicesFailure]: (state, action) => {
    // TODO: move this value to redux store later
    const currentFerryGroupingIndex = 0;
    state.fetchingStatus[currentFerryGroupingIndex][
      action.payload.segmentId
    ] = false;
  },
  [setFerryServices]: (state, action) => {
    // TODO: move this value to redux store later
    const currentFerryGroupingIndex = 0;
    state.ferryGrouping[currentFerryGroupingIndex][action.payload.segmentId] =
      action.payload.services;
  },
});
